module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Option-9886e29c9aabb7c91a37e5bb99435e67.svg";